import {Component, OnInit} from '@angular/core';

import {AuthRESTService} from "../../../services/rest/auth-rest.service";
import Commons from "../../commons";
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { MetaPropertySchema } from '../../../../models/metaPropertySchema';
import {Router} from '@angular/router';
import { AppWidgetModule } from 'app/components/widgets/widget.module';
import { SharedModule } from 'app/shared.module';

@Component({
    standalone: true,
    imports: [SharedModule, AppWidgetModule],
    templateUrl: './user-create.component.html'
})
export class UserCreatePage extends Commons implements OnInit {
	userProps: any = [];
	errorMessage = '';
	exceptPropNames = ['password'];

    constructor(private router: Router, private rest: AuthRESTService, toastr: ToastrService, translate: TranslateService) {
		super(toastr, translate);
	}

    ngOnInit(): void {
        this.rest.get('cas/configuration/property').subscribe(response => {
			this.userProps = response.filter((prop) => {
				if (!prop.usedOnForm) return false;
				if (this.exceptPropNames.some((exceptPropName) => {
					if (exceptPropName === prop.name) return true;
				})) { // except this one
					return false;
				}
				return true;
			}).sort((a, b) => { return a.ordering - b.ordering }).map((prop) => {
				prop.display = JSON.parse(prop.display);
				let result = new MetaPropertySchema();
				result.translateService = this.translate;
				return Object.assign(result, prop);
			});
        }, err => this.errorHandler(err));
    }

    save(): void {
		this.clearNotifications();
		let result = { name: null, properties: [] };
		this.userProps.forEach((prop) => {
			if (!prop.value) return;
			if (prop.name === "name") {
				result.name = { id: prop.id,  value: prop.value };
			}
			result.properties.push({ id: prop.id,  value: prop.value });
		});
        this.rest.put('profile', result).subscribe((response) => {
				this.addSuccess('general.saved');
				this.router.navigate(['/user/' + response.id + '/edit/']);
            }, err => {
				if (!err.error) {
					this.errorHandler(err);
					return;
				}
				const serverError = JSON.parse(err.error);
				if (!serverError.messages) {
					this.errorHandler(err);
					return;
				}
				let errMessage = [];
				serverError.messages.forEach((msg) => {
					this.userProps.some((prop) => {
						if (prop.id === msg.propId) {
							errMessage.push(prop.label + ': ' + msg.message);
							return true;
						}
					});
				});
				this.errors = errMessage;
			}
        )
    }

}
